import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CancelIcon, SearchesCIcon, CloseIcon, LeftArrow } from "../Assets/iconshere";
import Filter from "./Filter/Filter";
import LottiePlayer from "lottie-react";
import noDataFound from "../Assets/animationIcons/noDataFound.json";
import Skeleton from "react-loading-skeleton";
import apiClient from "../apiClient";

const UsersTab = ({
  search = "",
  setSearch = "",
  roleList = [],
  onSelect,
  setActiveTab,
  redirected,
  setRedirected,
}) => {
  var params = useParams();
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  var { uuid } = params;
  const [usersList, setUsersList] = useState([]);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [filterOptions, setFilterOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchUsers = async () => {
    try {

      const data = await apiClient.get(`${configData.config.UNO_URL}/api/user/list/${uuid}`);

      // let { data } = await axios.get(`${configData.config.UNO_URL}/api/user/list/${uuid}`, {
      //   headers: {
      //     Authorization: `Bearer ${userData.token}`,
      //   },
      // });

      setLoading(false);
      let uniqueArrayDesignation = [
        ...new Set(data.map((e) => (e.designation ? e.designation.trim() : "Undefined"))),
      ]
        .sort()
        .map((e) => ({ id: e, name: e }));
      setUsersList(data);

      let formattedDesignationData = {
        name: "Designation",
        tags: uniqueArrayDesignation,
      };

      let formattedAllocationData = {
        name: "Role",
        tags: roleList.map((e) => ({ id: e.id, name: e.name })).sort((c, d) => c.name.localeCompare(d.name)),
      };

      setFilterOptions([formattedAllocationData, formattedDesignationData]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [uuid]);

  useEffect(() => {
    setSelectedCheckboxes([]);
  }, []);

  const handleCancelTag = (item) => {
    setSelectedCheckboxes((prevSelected) => prevSelected.filter((selectedItem) => selectedItem !== item));
  };

  const filterCourses = (user) => {
    if (
      search.length &&
      !(
        (user.name && user.name.toLowerCase().includes(search.toLowerCase())) ||
        (user.email && user.email.toLowerCase().includes(search.toLowerCase())) ||
        (user.uid && user.uid.toLowerCase().includes(search.toLowerCase()))
      )
    )
      return false;

    if (selectedCheckboxes.length) {
      var designationFilters = selectedCheckboxes.filter((e) => typeof e.id == "string");
      var roleFilters = selectedCheckboxes.filter((e) => !designationFilters.includes(e)).map((e) => e.id);
      const roleallocation =
        user.roleAllocations.length > 1
          ? user.roleAllocations.filter((e) => e.role.type !== "DEFAULT")[0]
          : user.roleAllocations[0];
      const { role } = roleallocation;
      if (roleFilters.length && !roleFilters.includes(role.id)) return false;
      if (designationFilters.length && !designationFilters.map((e) => e.id).includes(user.designation)) return false;
    }
    return true;
  };

  let filteredList = usersList.filter(filterCourses);

  const loadBox = 5;
  const tileCards = [];

  for (let i = 0; i < loadBox; i++) {
    tileCards.push(
      <div key={`tile-${i}`} className="tilecard p-0 mb-3" style={{ outline: "none" }}>
        <div className="groupcardesign">
          <div className="avatarimg p-0" style={{ outlineColor: "#ffffff00" }}>
            <Skeleton count={1} circle height="100%" width="100%" className="m-0 p-0" />
          </div>
          <h6 className="groupname"> </h6>
          <div className="groupusercount d-flex flex-column gap-2">
            <p>
              <Skeleton width="10vw" className="my-1" />{" "}
            </p>
            <p>
              <Skeleton width="10vw" className="my-1" />{" "}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="row pt-4 mt-3">
        <div className="col-md-6 d-flex align-items-center justify-content-start">
          {redirected && (
            <button
              onClick={() => {
                setActiveTab("Dashboard");
                setRedirected(false);
              }}
              className="backbtn cursor-pointer "
              title="Back"
            >
              <LeftArrow />
              Back
            </button>
          )}{" "}
          {null}
        </div>
        <div className="col-md-6 d-flex align-items-center justify-content-end">
          <form className=" app-search app-search1 d-flex justify-content-start me-2">
            <div className="position-relative">
              <SearchesCIcon />
              {search.length > 0 && (
                <span className="searchiconcancel" onClick={() => setSearch("")}>
                  <CancelIcon />
                </span>
              )}
              <input
                type="text"
                name="searchName"
                className="form-control"
                placeholder="Search"
                autoComplete="off"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </form>
          <Filter
            selectedCheckboxes={selectedCheckboxes}
            setSelectedCheckboxes={setSelectedCheckboxes}
            filterOptions={filterOptions}
          />
        </div>

        {selectedCheckboxes.length > 0 && (
          <div className="filerlist mt-3">
            <span>Filters:</span>
            {selectedCheckboxes.map((f) => {
              return (
                <span className="filtertag">
                  {f.name}
                  <span onClick={() => handleCancelTag(f)}>
                    <CloseIcon />
                  </span>
                </span>
              );
            })}
            <span className="filtertag clear" onClick={() => setSelectedCheckboxes([])} style={{ cursor: "pointer" }}>
              Clear all
            </span>
          </div>
        )}
      </div>

      <div className="courses-parent usergrouplist">
        {loading ? (
          <div className="course-tiles mt-2">{tileCards}</div>
        ) : (
          <>
            {filteredList.length > 0 ? (
              <div className="course-tiles mt-2">
                {filteredList.map((user, index) => {
                  return (
                    <div className="tilecard p-0" key={user.uuid} onClick={() => onSelect(user)}>
                      <div className="usercardesign">
                        {user.avatar ? (
                          <div className="avatarimg">
                            <img
                              src={user.avatar}
                              referrerPolicy="no-referrer"
                              alt={`Avatar for ${user.name}`}
                              title={user.name}
                            />
                          </div>
                        ) : (
                          <div className="initials-placeholder">
                            {user?.name
                              ?.split(" ")
                              .map((word) => word[0])
                              .slice(0, 2)
                              .join("")}
                          </div>
                        )}

                        <h6 className="groupname">{user.name}</h6>
                        <p>{user.email}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center mt-5">
                <LottiePlayer animationData={noDataFound} style={{ height: 200 }} autoplay loop />
                <h5>No User Found</h5>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default UsersTab;
